import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { User } from '../../entities/user/user.entity';
import { AbstractHttpService } from '../http/http-service.abstract';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    currentUser$: Observable<User>;

    constructor(private readonly http: AbstractHttpService) {
        this.currentUser$ = this.getCurrentUser().pipe(shareReplay(1));
    }

    private getCurrentUser(): Observable<User> {
        return this.http.get('users/current');
    }
}
